import { FeatureFlag } from '@ps/web-core-enums';
import { type Page, useFeature } from '@ps/web-core-store';
import React from 'react';

import StarsLayoutBase from './StarsLayoutBase';
import StarsLayoutV2 from './StarsLayoutV2';
import StarsLayoutV3 from './StarsLayoutV3';

const StarsLayout: React.FC<Page> = (page) => {
  const isPrototype3Enabled = useFeature(FeatureFlag.PKRNavDesignV2);
  const isPrototype4Enabled = useFeature(FeatureFlag.PKRNavDesignV3);

  if (isPrototype3Enabled) {
    return <StarsLayoutV2 {...page} />;
  }

  if (isPrototype4Enabled) {
    return <StarsLayoutV3 {...page} />;
  }

  return <StarsLayoutBase {...page} />;
};

export default StarsLayout;
